module.exports = __webpack_public_path__ + "static/media/t3.acbe7991.jpg";